import { render } from "./iosDownloadInstructions.vue?vue&type=template&id=1842f322&ts=true"
import script from "./iosDownloadInstructions.vue?vue&type=script&lang=ts"
export * from "./iosDownloadInstructions.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__